import React from 'react'
import { Button, FormFeedback, Col, Form, Row, Label } from 'reactstrap';
import './styleM.css';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { Password } from 'primereact/password';
import { Toast } from 'primereact/toast';



export const ModalAutorization = (props) => {

    const {
        user_method,
        user_password_method,
        handleInputChangeMethod,
        modalAutorization,
        toggleModalAutorization,
        validatePasswordFinance,
        handleCancelAutorization,
        configuration_role,
        handleSendNotificationInvoices,
        toasts
    } = props;

    return (
        <>
            <Toast ref={toasts} position="top-right" className="toast-custom" />
            <Dialog
                header={"Autorizar factura"}
                visible={modalAutorization}
                onHide={toggleModalAutorization}
                closable
                headerStyle={{
                    backgroundColor: '#0f172a',
                    color: 'white',
                    fontWeight: 'bold',
                }}
                pt={{
                    header: { style: { backgroundColor: '#0f172a', color: 'white' } },
                    headerIcon: { style: { color: 'white' } },
                }}
                modal
                appendTo="self"
                className="dialog-change-right"
                draggable={false}
                maskClassName="custom-total-mask"
                footer={
                    <div className="d-flex justify-content-end gap-2">
                        {
                            configuration_role === "True" ? <>
                                <Button
                                    color="secondary"
                                    type="button"
                                    onClick={validatePasswordFinance}
                                >
                                    Autorizar
                                </Button>

                                <Button
                                    color="danger"
                                    type="button"
                                    onClick={handleCancelAutorization}
                                >
                                    Cancelar
                                </Button>
                            </>
                                :
                                <Button
                                    color="secondary"
                                    type="button"
                                    onClick={handleSendNotificationInvoices}
                                >
                                    Aceptar
                                </Button>
                        }
                    </div>
                }
            >
                <Form className="form theme-form pt-4" role="form">
                    {
                        configuration_role === "True" ?
                            <>
                                <Row className="align-items-stretch">

                                    <Col md="3" className="d-flex justify-content-center align-items-center border-end">

                                        <div className="side-lock-wrapper-2">
                                            <img
                                                src={require("../../assets/images/blog/password.svg")}
                                                alt="user"
                                                className="side-lock-icon"
                                            />
                                        </div>
                                    </Col>

                                    <Col md="9">
                                        <Row className="g-3 mb-3">
                                            <Col md="6">
                                                <Label className="form-label-sm">Usuario</Label>
                                                <InputText
                                                    value={user_method}
                                                    name="user_method"
                                                    onChange={handleInputChangeMethod}
                                                    required={true}
                                                    autoComplete="nope"
                                                    className="p-mb-2"
                                                    style={{ width: '100%' }}
                                                />
                                                <FormFeedback>Escribe el usuario</FormFeedback>
                                            </Col>

                                            <Col md="6">
                                                <Label className="form-label-sm">Contraseña</Label>
                                                <Password
                                                    name="user_password_method"
                                                    value={user_password_method}
                                                    onChange={handleInputChangeMethod}
                                                    feedback={false}
                                                    className="p-mb-2"
                                                    style={{ width: '100%' }}
                                                    inputStyle={{ width: '100%' }}
                                                />
                                                <FormFeedback>Escribe el usuario</FormFeedback>
                                            </Col>

                                        </Row>
                                    </Col>
                                </Row>
                            </>
                            :
                            <Col sm="12" style={{ textAlign: "center" }} className='p-l-0 p-r-0 '>

                                <img className="img-fluid" src={require("../../assets/images/loginHelenLabs/dashboard/recepcionista.svg")} style={{ width: "50%" }} alt="" />
                                <br />
                                <p className='f-w-600 f-14 badge badge-light-danger' >Contacte a Administracion.</p>
                            </Col>
                    }
                </Form>
            </Dialog>
        </>
    )
}
